import { styled } from "baseui";

export const Heading = styled("h3", ({ $theme }) => ({
  ...$theme.typography.HeadingSmall,
  fontWeight: 700,
  color: $theme.colors.contentPrimary,
}));
